import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { SanitizeHtml, GoogleMapUrl } from '@bd/bdcore-utilities';
import CoreMap from '@bd/bdui-coremap';
import { colors } from '../../styles';

const styles = css`
  .Directions_wrapper {
    background-color: ${colors.neutral};
    height: 100%;
    padding: 30px;
  }
`;

const CommunityDirections = ({ home, community }) => {
  const homeMarkers = [
    home,
  ];
  return (
    <div className={styles}>
      <div className="container">
        <div className="row">
          <div className="col-lg-4 pr-lg-0">
            <div className="Directions_wrapper">
              {
                get(community, 'directions') &&
                <div className="mb-4" dangerouslySetInnerHTML={SanitizeHtml(get(community, 'directions'))} />
              }
              <a href={GoogleMapUrl(home)} target="_blank" rel="noopener noreferrer" className="btn">
                Get Directions
              </a>
            </div>
          </div>
          <div className="col-lg-8 pl-lg-0">
            <CoreMap
              className={css`
                height: 500px;
                width: 100%;
                .leaflet-container {
                  height: 100%;
                  width: 100%;
                }
              `}
              pin={{
                iconUrl: '/images/icon-map-pin.svg',
              }}
              markers={homeMarkers}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

CommunityDirections.propTypes = {
  community: PropTypes.object.isRequired,
  home: PropTypes.object.isRequired,
};

export default CommunityDirections;



// WEBPACK FOOTER //
// ./src/pages/HomeDetail/HomeDirections.js